import styled from 'styled-components';
import sizeStandards from '../../size-standards';
import getTypographyConfig from '../../typography-config';

const TextWrapper = styled.p`
  margin: 8px 0;

  ${({ size, language }) => {
    const typography = getTypographyConfig(language);

    const getSize = (s, map) => {
      if (s === 'LG') return map.LG;
      if (s === 'MD') return map.MD;
      if (s === 'SM') return map.SM;

      return map.MD;
    };

    const desktop = {
      LG: sizeStandards.font.LG,
      MD: sizeStandards.font.MD,
      SM: sizeStandards.font.SM,
    };

    const tablet = {
      LG: sizeStandards.font.MD,
      MD: sizeStandards.font.SM,
      SM: sizeStandards.font.XS,
    };

    const mobile = {
      LG: sizeStandards.font.SM,
      MD: sizeStandards.font.XS,
      SM: sizeStandards.font.XS,
    };

    return `
      font-size: ${getSize(size, desktop) * typography.scale}px;
      line-height: ${typography.lineHeight};
      font-weight: ${typography.fontWeight};
      font-family: ${typography.fontFamily};

      @media only screen and (max-width: ${sizeStandards.screen.LG}px) {
        font-size: ${getSize(size, tablet) * typography.scale}px;
      }

      @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
        font-size: ${getSize(size, mobile) * typography.scale}px;
      }
    `;
  }}
`;

export default TextWrapper;
